export default {
  auth: {
    back: 'Regresar para inicio de sesión',
    email: {
      title: 'Entrar',
      subtitle: '¿Qué tal emprender este viaje ahora?',
      placeholder: {
        email: 'Ingresa el correo electrónico de tu cuenta PlayKids',
        password: 'Ingresa tu contraseña'
      },
      forgotPassword: '¿Olvidaste tu contraseña?, clique aquí',
      signIn: 'Entrar',
      signInMethodsSeparator: 'O',
      playphoneRouter: 'Conéctate con PlayPhone',
      note: 'Inicio de sesión con número telefónico: Servicio disponible solo a través de la aplicación instalada en su dispositivo móvil. Accede al enlace que te enviamos por SMS.',
      signUp: {
        message: '¿No tienes cuenta?',
        CTA: 'Inscríbete'
      },
      error: {
        email: 'Ingresa un email válido',
        password: 'Ingresa una contraseña válida',
        invalidRequest: 'Hay algo errado con los datos proporcionados',
        wrongCredentials:
          'Email no registrado o contraseña incorrecta.\nPor favor intenta nuevamente.',
        generic: 'Ocurrió algún error.'
      }
    },
    apple: {
      signIn: 'Entrar con Apple',
      signUp: 'Regístrate con Apple'
    },
    facebook: {
      signIn: 'Entrar con Facebook',
      signUp: 'Regístrate con Facebook'
    },
    playphone: {
      title: 'Conéctate con PlayPhone',
      subtitle: 'El mejor contenido educativo para tus hijos está aquí.',
      placeholder: {
        email: 'Tu email de Playphone'
      },
      signIn: 'Entrar',
      error: {
        email: 'Ingresa un email válido',
        generic:
          '¡Ups! No pudimos encontrar ninguna cuenta registrada con este email.'
      }
    },
    playphoneLastStep: {
      title: 'último paso',
      subtitle: 'Ingresa tu ID de usuario para iniciar sesión',
      placeholder: {
        email: 'Tu email de Playphone'
      },
      signIn: 'Entrar',
      forgotUserId: {
        message: '¿Olvidaste tu ID de usuario?',
        CTA: 'Clique aquí.'
      },
      error: {
        email: 'Ingresa un email válido.',
        generic:
          '¡Ups! No pudimos encontrar ninguna cuenta registrada con este email.'
      }
    },
    forgotPassword: {
      title: '¿Olvidaste tu contraseña?',
      subtitle:
        '¡No te preocupes! Te enviaremos un enlace a tu email para que puedas restablecerla. :)',
      placeholder: 'Ingresa tu email de PlayKids',
      send: 'Enviar',
      success:
        'Enlace enviado a <b>{email}</b><br/>Revisa tu correo electrónico en unos momentos.',
      error: {
        email: 'Ingresa un email válido.',
        generic:
          '¡Ups! No pudimos enviar el enlace a este email.\nVerifique el email ingresado e intenta nuevamente.'
      }
    },
    signUp: {
      hero: {
        title: '¡Regístrate aquí, diviértete donde quieras!',
        content:
          'Con tu suscripción accedes a PlayKids en tu smartphone, computadora o smartv. Así la diversión y el conocimiento siempre están cerca de tu familia.'
      },
      title: '¡Inscríbete en PlayKids!',
      subtitle:
        'No te preocupes, tus datos solo serán utilizados de forma segura por PlayKids y para garantizar una experiencia completa.',
      placeholder: {
        email: 'Email del responsable',
        password: 'Crea una contraseña',
        cpf: 'Ingresa tu CPF',
        code: 'Ingresa tu código de cliente'
      },
      signUp: 'Registrar',
      signUpMethodsSeparator: 'O',
      methods: {
        facebook:
          'Para hacerlo más fácil, puedes crear tu cuenta usando Facebook',
        partner:
          '¿Vienes por medio de algún socio de PlayKids? Entonces haga clic aquí',
        partnerCta: 'Continuar a través de un socio'
      },
      partners: {
        title: 'Continuar a través de un socio',
        sky: {
          text: 'Continúa tu registro utilizando tus datos de SKY TV',
          cta: 'Continuar a través de Sky TV'
        },
        playphone: {
          text: 'Continúa tu registro utilizando tus datos de proveedor de servicios de Internet',
          cta: 'Continuar a través de un proveedor de servicios de Internet'
        }
      },
      signIn: {
        message: '¿Ya tienes una cuenta?',
        CTA: 'Clica aquí para entrar'
      },
      error: {
        email: 'Ingresa un email válido.',
        password:
          'La contraseña debe tener entre 8 y 30 caracteres (letras y números).',
        emailAlreadyExists: {
          message:
            'Encontramos una cuenta PlayKids registrada con este email.<br/>¿Te gustaría ',
          CTA: 'entrar?'
        },
        invalidRequest: 'Hay algo errado con los datos proporcionados.',
        generic: 'Ocurrió algún error',
        ifoodEmail: 'Ingresa un email iFood válido.'
      }
    },
    resetPassword: {
      title: 'Restablece tu contraseña',
      subtitle:
        'Una buena contraseña debe ser fuerte, pero también facil de recordar',
      placeholder: {
        password: 'Ingresa tu nueva contraseña',
        confirmPassword: 'Confirma tu nueva contraseña'
      },
      reset: 'Restablecer contraseña',
      success: 'Contraseña alterada con éxito',
      error: {
        password:
          'La contraseña debe tener al menos 8 caracteres (letras y números).',
        passwordsDontMatch: '¡Las contraseñas no coinciden!',
        invalidRequest: 'Error al intentar crear la contraseña',
        expiredToken: {
          message: 'Tu enlace expiró, intenta',
          CTA: 'reenviarlo'
        },
        generic: 'Ocurrió algún error'
      }
    },
    emailOnly: {
      title: 'Empieza ahora a combinar<br/>aprendizaje y diversión',
      subtitle: 'Inicie sesión en tu cuenta o crea una nueva.',
      access: 'Entrar',
      signInMethodsSeparator: 'O',
      placeholder: {
        email: 'Ingresa tu email'
      },
      playphoneRouter: 'Conéctate con PlayPhone',
      error: {
        email: 'Ingresa un email válido.',
        invalidRequest: 'Hay algo errado con los datos proporcionados.',
        generic: 'Ocurrió algún error.'
      }
    },
    passwordOnly: {
      title: '¡Ya tienes una cuenta!',
      subtitle: 'Necesitamos tu contraseña para continuar.',
      placeholder: {
        password: 'Ingresa tu contraseña'
      },
      forgotPassword: 'Olvidé mi contraseña',
      signIn: 'Entrar',
      error: {
        password:
          ':La contraseña debe tener al menos 8 caracteres (letras y números).',
        invalidRequest: 'Hay algo errado con los datos proporcionados.',
        wrongCredentials:
          'Email no registrado o contraseña incorrecta.\nPor favor intenta nuevamente.',
        generic: 'Ocurrió algún error'
      }
    }
  },
  common: {
    format: {
      date: 'DD/MM/YYYY',
      dateRaw: 'DDMMYYYY'
    }
  },
  policies: {
    privacy: 'Al usar los servicios de Playkids, usted acepta nuestra',
    privacyTitle: 'Política de privacidad',
    privacyLink: 'https://policies.playkidsapp.com/es/privacy',
    tos: 'Al usar los servicios de Playkids, usted acepta nuestros',
    tosTitle: 'Términos de uso',
    tosLink: 'https://policies.playkidsapp.com/es/tos'
  },
  checkout: {
    registerKid: {
      title: 'Para cada niño, <br/>una experiencia diferente',
      description:
        'Al ingresar los datos, te aseguras de que el contenido adecuado para el grupo de edad de la niña o niño esté a su alcance.',
      form: {
        title: '¡Genial! Vamos a crear un nuevo perfil.',
        description:
          '¡Con el perfil, la niña o niño tendrá acceso al contenido más adecuado para ella o él!',
        inputName: 'Nombre de la niña o niño',
        inputBirthDate: 'Fecha de nacimiento',
        cancelButtonLabel: 'Cancelar',
        saveButtonLabel: 'Crear perfil',
        updateButtonLabel: 'Guardar cambios',
        successCreateMessage: 'El perfil de {name} fue creado',
        successUpdateMessage: 'El perfil de {name} fue modificado',
        successDeleteMessage: 'El perfil de {name} fue removido',
        errorCreateMessage: 'Ocurrió un error al crear el perfil de {name}',
        errorUpdateMessage: 'Ocurrió un error al modificar el perfil de {name}',
        errorDeleteMessage: 'Ocurrió un error al remover el perfil de {name}'
      },
      list: {
        buttonLabel: 'Crear nuevo perfil',
        card: {
          name: 'Nombre de la niña o niño',
          birthDate: 'Fecha de Nacimiento',
          editButton: 'Editar datos'
        }
      },
      removeModal: {
        title: '¿Está seguro de que desea remover el perfil de',
        cancelButton: 'Cancelar',
        removeButton: 'Remover perfil'
      }
    },
    planSelector: {
      title: '¡Lo mejor comenzará ahora!',
      loading: 'Cargando planes...',
      description:
        'Elige tu plan y emprende este viaje lleno de diversión y conocimiento.',
      planBox: {
        month: 'mes',
        months: 'meses',
        priceLabel: {
          month: 'por mes',
          year: 'En 1x'
        },
        priceDetails: 'En este plan el monto mensual sale por',
        paymentDetails: 'cobrado una vez.'
      }
    },
    payment: {
      navTabs: {
        itemCard: 'Pagar con tarjeta',
        itemCoupon: 'Pagar con cupón'
      },
      cardTab: {
        title: 'Rellena tus datos',
        description:
          '¡Estamos cada vez más cerca del Mundo PlayKids! Ingresa tus datos y tu tarjeta de crédito para registrarte.',
        planDetails:
          'Tendrás un mes de regalo para explorar el Mundo PlayKids. El cargo por la cantidad de {planPrice} solo se realizará después del final de los 30 días. Puedes cancelar antes de que finalice la prueba.',
        form: {
          personalSection: {
            title: 'Datos personales',
            documentLabel: 'CPF',
            addressLabel: 'Dirección',
            addressZipCodeLabel: 'CEP',
            addressDistrictLabel: 'Barrio',
            addressNumberLabel: 'Número',
            addressComplementLabel: 'Complemento',
            addressCityLabel: 'Ciudad',
            addressStateLabel: 'Estado'
          },
          paymentSection: {
            title: 'Datos de pago',
            documentLabel: 'CPF',
            emailLabel: 'E-mail',
            cardNumberLabel: 'Número de tarjeta',
            cardHolderNameLabel: 'Nombre impreso en la tarjeta',
            cardExpirationMonthLabel: 'Mes',
            cardExpirationYearLabel: 'Año'
          }
        }
      },
      couponTab: {
        title: 'Rellena los datos de tu cupón',
        description:
          '¡Estamos cada vez más cerca del Mundo PlayKids! Ingresa tu cupón para finalizar el registro.',
        form: {
          couponLabel: 'Ingresa tu cupón',
          couponInput: 'Cupón de descuento'
        }
      }
    },
    checkoutPaymentSucceeded: {
      title: 'Hola, que bueno es tenerte aquí con nosotros.',
      subtitle: 'Antes que nada, ¡Su suscripción está confirmada!',
      description:
        '¡Ahora los niños podrán disfrutar del universo PlayKids accediendo a todos nuestros contenidos a través de smartphones, tablets, computadoras e incluso smart TVs! <br/><br/><strong>¡PlayKids está en todas partes!</strong><br/><br/> ¡Para acceder a PlayKids en otros dispositivos, simplemente busqué la aplicación en la tienda de tu dispositivo e inicia sesión con su cuenta PlayKids!',
      finish: 'comenzar'
    }
  },
  account: {
    credentials: {
      title: 'Datos de la cuenta',
      facebook: {
        title: 'Su inicio de sesión es a través de Facebook',
        text: 'Nunca publicaremos nada en tu cuenta ni enviaremos mensajes a tus contactos.'
      }
    },
    status: {
      subscription: {
        type: {
          title: 'Tipo de suscripción',
          values: {
            SEMESTERLY: 'Semestral',
            YEARLY: 'Anual'
          }
        },
        status: {
          title: 'Estado de la suscripción',
          values: {
            ACTIVE: 'Activa'
          }
        },
        expiration: {
          title: 'Vencimiento'
        },
        cancelCta: 'Cancelar suscripción'
      }
    },
    payments: {
      title: 'Pagos',
      datePayment: 'Tu próximo cobro será el: ',
      dateCancellation: 'La suscripción caducará el: ',
      howToChange: 'Cómo cambiar la suscripción'
    },
    changeEmail: {
      title: 'Cambiar email',
      emailPlaceholder: 'Ingresa tu nueva dirección de email',
      passwordPlaceholder: 'Ingresa tu contraseña actual',
      errors: {
        403: 'Contraseña incorrecta',
        409: 'Este email ya está siendo utilizado',
        same: 'Este email ya está siendo utilizado por ti'
      },
      cancel: 'Cancelar',
      cta: 'Cambiar email',
      success: 'Email modificado'
    },
    changePassword: {
      title: 'Cambiar contraseña',
      placeholders: {
        current: 'Ingresa tu contraseña actual',
        new: 'Ingresa tu nueva contraseña (min, 8 caracteres)',
        confirm: 'Confirma tu nueva contraseña'
      },
      errors: {
        403: 'La contraseña actual es incorreta',
        generic: 'Vaya, no pudimos registrar su nueva contraseña.'
      },
      success: '¡Contraseña modificada con éxito!',
      cta: 'Cambiar contraseña'
    },
    cancelSubscription: {
      title: '¿Estás seguro de que deseas cancelar tu suscripción?',
      textDate:
        'Si cancelas ahora, tendrás acceso al contenido hasta el [DATE]. Puedes volver a suscribirte en cualquier momento.',
      textFooter: 'PlayKids siempre será un ambiente seguro y educativo.',
      errorLine: 'No pudimos cancelar su suscripción.',
      cancel: 'Regresar',
      cta: 'Cancelar suscripción',
      modalCta: 'Quiero cancelar',
      success: {
        title: 'Cancelamiento realizado con éxito',
        text1:
          'Esperamos que tu pequeño haya aprendido y se haya divertido mucho mientras estuvimos juntos.',
        text2:
          'Por último, ¿Podría responder una encuesta rápida para ayudarnos?',
        formCta: 'Responder encuesta'
      }
    }
  },
  misc: {
    backButtonText: 'Regresar',
    developmentTagsTitle: 'Ejes de Desarrollo',
    logoutButtonText: 'Salir',
    season: '{n} Temporada | {n} Temporadas',
    episodes: 'Episodios',
    ageAdvise:
      'Todos los shows de PlayKids son apropiados para todas las edades, pero algunos temas se entienden mejor en etapas específicas del desarrollo de su pequeño.',
    termsOfUse: {
      text: 'Terminos de uso',
      url: 'https://cdn.pkds.it/policy/ios/tos-es.html'
    },
    privacyPolicy: {
      text: 'Política de privacidad',
      url: 'https://cdn.pkds.it/policy/ios/privacy-es.html'
    },
    creditCard: {
      securityCodeLabel: 'Código de <br/>seguridad',
      expiration: {
        month: 'MM',
        year: 'AAAA'
      }
    }
  },
  inactive: {
    message:
      'Aparentemente, no tienes una suscripción a PlayKids activa, por lo que no puedes acceder a nuestro contenido <span>:(</span>'
  },
  downloadAppBanner: {
    title: '¡Descarga la aplicación PlayKids!',
    text: '¡Videos, libros y juegos para aprender mientras te diviertes!',
    CTA: 'Descargar'
  },
  demo: {
    badge: 'Versión demo',
    dialog: {
      text: '¿Quieres acceder al contenido completo?',
      CTA: '¡Suscríbete ahora!'
    }
  },
  header: {
    message: '¿Ya tienes una cuenta?',
    button: 'Entrar'
  },
  menu: {
    account: 'cuenta',
    support: 'Ayuda',
    logout: 'Salir'
  },
  footer: {
    title: '¿Tienes dudas?',
    links: {
      questions: {
        title: 'Central de Ayuda',
        url: 'https://help.playkids.com'
      },
      termsOfUse: {
        title: 'Terminos de uso',
        url: 'https://policies.playkidsapp.com/es/tos'
      },
      privacyPolicy: {
        title: 'Política de privacidad',
        url: 'https://policies.playkidsapp.com/es/privacy'
      },
      cookiePolicy: {
        title: 'Política de cookies',
        url: 'https://policies.playkidsapp.com/es/cookie'
      }
    }
  },
  partnerships: {
    form: {
      authenticated: {
        title:
          'Ingresa los detalles de tu cuenta para terminar de crear tu acceso',
        inputEmail: 'Ingresa el email de tu cuenta PlayKids',
        inputCode: 'Ingresa tu código de cliente',
        cancelButton: 'Cancelar',
        confirmButton: 'Confirmar'
      },
      signIn: {
        inputEmail: 'Ingresa email de tu cuenta PlayKids',
        inputPassword: 'Ingresa tu contraseña de acceso',
        cta: 'Entrar'
      },
      signInOption: {
        title: '¿Ya tienes una cuenta PlayKids?',
        cta: 'Clique aquí para entrar'
      },
      signUpOption: {
        title: '¿No tienes cuenta PlayKids?',
        cta: 'Regístrate'
      },
      signUp: {
        inputEmail: 'Ingresa el email para tu cuenta PlayKids',
        inputConfirmEmail: 'Confirma el email de tu cuenta PlayKids',
        inputPassword: 'Crea tu contraseña de acceso',
        inputPasswordHint:
          'La contraseña debe tener entre 8 y 30 caracteres (letras y números).',
        cta: 'Crear cuenta PlayKids'
      },
      success: {
        title: '¡Genial! ¡Tu registro se ha completado con éxito!',
        description:
          '¡Ahora los niños podrán disfrutar del universo PlayKids accediendo a todos nuestros contenidos a través de smartphones, tablets, computadoras e incluso smart TVs!',
        subtitle: '¡PlayKids está en todas partes!',
        stores:
          '¡Para acceder a PlayKids en otros dispositivos, simplemente busqué la aplicación en la tienda de tu dispositivo e inicia sesión con su cuenta PlayKids!',
        signInTitle: '¡Genial! Ahora vamos a vincular tu cuenta PlayKids.',
        signInDescription:
          'Informa el email y la contraseña que ya usas para acceder a las aplicaciones de PlayKids',
        signInAuthenticatedTitle:
          '¡Genial! Se ha accedido con éxito a su cuenta.',
        authenticatedDescription:
          'Para finalizar el rescate de su beneficio, haga clic en el botón de rescate o cancele no realizar el rescate ahora.',
        signUpTitle: '¡Genial! Vamos a crear una cuenta PlayKids',
        signUpAuthenticatedTitle:
          '¡Genial! Su cuenta se ha creado correctamente.',
        signUpDescription:
          'Primero necesitamos que nos digas el email y la contraseña que usarás para acceder a las aplicaciones de PlayKids.'
      },
      errors: {
        inputEmail: 'Ingresa un email válido.',
        inputPassword: 'Ingresa una contraseña válida',
        inputCode: 'Ingresa un código de cliente válido',
        wrongCredentials:
          'Email no registrado o contraseña incorrecta.<br/>Por favor intenta nuevamente.',
        inputConfirmEmail: '¡Los emails no coinciden!',
        emailAlreadyExists:
          'Ya encontramos una cuenta PlayKids registrada con este email',
        generic:
          '¡Ups! Algo no funcionó como esperábamos al validar su registro.<br/>Inténtelo de nuevo más tarde.'
      },
      playhub: {
        validation: {
          internetProvider:
            'Escriba el nombre de su Proveedor de Servicios de Internet',
          inputUser: 'Escriba su nombre de usuario',
          inputPassword: 'Escriba la contraseña proporcionada por su Proveedor',
          headerTitle: '¡Vamos a validar tu cuenta!',
          headerDescription:
            'Completa la siguiente información con tus datos de un proveedor de servicios de Internet para liberar la creación de su cuenta.',
          validationButton: 'Validar'
        }
      }
    },
    playhub: {
      validation: {
        haederTitle: '¡Vamos a validar tu cuenta PlayHub!',
        headerDescription:
          'Completa la siguiente información con tus datos de PlayHub para liberar la creación de su cuenta.',
        validationButton: 'Validar'
      }
    }
  },
  tags: {
    body_expression: 'Expresión corporal',
    directions: 'Direcciones',
    spatial_orientation: 'Orientación Espacial',
    temporal_orientation: 'Orientación Temporal',
    sports_and_activities: 'Deportes y Actividades',
    drawing: 'Dibujo',
    painting: 'Pintura',
    writing: 'Escritura',
    handmade_activities: 'Actividades Manuales',
    balance: 'Equilibrio',
    vocabulary_and_words: 'Vocabulario y Palabras',
    image_interpretation: 'Interpretación de Imágenes',
    phonemes_and_alphabet: 'Fonemas y Alfabeto',
    colors: 'Colores',
    sounds_and_sound_sources: 'Sonidos y Fuentes Sonoras',
    artistic_language: 'Lenguaje Artístico',
    reading_and_fluency: 'Lectura y Fluidez',
    grammar: 'Gramática',
    genres_and_textual_types: 'Géneros y Tipos de Texto',
    fantasy_and_imagination: 'Fantasía e Imaginación',
    musical_scale_and_styles: 'Escala y Estilos Musicales',
    musical_instruments: 'Instrumentos Musicales',
    artistic_expression: 'Expresión Artística',
    language: 'Idiomas',
    songs_and_rhymes: 'Canciones y Ritmos',
    symbols: 'Símbolos',
    numbers: 'Números',
    shapes: 'Formas',
    counting: 'Conteo',
    sorting: 'Ordenación',
    measurement: 'Medición',
    comparison: 'Comparación',
    capacity: 'Capacidad',
    series_and_sequences: 'Series y Secuencias',
    values: 'Dinero y Valores',
    charts_and_tables: 'Gráficos y Tablas',
    quantities: 'Cantidades',
    finance: 'Finanzas',
    operations: 'Operaciones Matemáticas',
    biology_and_life: 'Biología y Vida',
    fauna_and_flora: 'Fauna y Flora',
    geography_and_phenomena: 'Geografía y Fenómenos',
    outer_space: 'Espacio Sideral',
    physics: 'Física',
    chemistry: 'Química',
    body_and_health: 'Cuerpo y Salud',
    foods: 'Alimentos',
    senses_and_sensations: 'Sentidos y Sensaciones',
    auditory_attention: 'Atención Auditiva',
    temporal_perception: 'Percepción Temporal',
    spatial_perception: 'Percepción Espacial',
    shape_perception: 'Percepción de Figuras y Formas',
    memory: 'Memoria',
    attention: 'Atención',
    concentration: 'Concentración',
    problem_solving: 'Solución de Problemas',
    logic: 'Lógica',
    empirical_knowledge: 'Conocimiento Empírico',
    decision_making: 'Toma de Decisiones',
    games_and_toys: 'Juegos y Juguetes',
    family: 'Familia',
    citizenship_and_ethics: 'Ciudadanía y Ética',
    holidays_and_celebrations: 'Fiestas y Celebraciones',
    cultures_and_mores: 'Costumbres y Cultura',
    work_and_occupation: 'Empleos y Profesiones',
    history: 'Historia',
    places_and_landscapes: 'Lugares y Paisajes',
    transport: 'Medios de Transporte',
    media: 'Medios de Comunicación',
    objects_and_transformations: 'Objetos y Transformaciones',
    sustainability: 'Sustentabilidad',
    tech: 'Tecnología',
    safety: 'Seguridad',
    collectivity: 'Colectividad',
    empathy: 'Empatía',
    social_participation: 'Participación social',
    respect_and_tolerance: 'Respeto y Tolerancia',
    equality: 'Igualdad',
    justice: 'Justicia',
    relationships: 'Construcción de Relacionamientos',
    duties_and_rights: 'Derechos y Deberes',
    physical_characteristics: 'Características Físicas',
    feelings_and_emotions: 'Sentimientos y Emociones',
    fear_and_frustration: 'Miedo y Frustración',
    habits_and_routine: 'Hábitos y Rutina',
    clothing: 'Ropa',
    hygiene_and_welfare: 'Higiene y Bienestar',
    behavior: 'Comportamiento',
    needs: 'Necesidades',
    genres: 'Géneros',
    protagonism: 'Protagonismo',
    creativity: 'Creatividad',
    autonomy: 'Autonomía',
    self_control_and_resilience: 'Autocontrol y Resiliencia',
    graphic_language: 'Lenguaje Gráfico',
    images_and_shapes: 'Imágenes y Formas',
    idioms: 'Idiomas',
    food_and_alimentation: 'Alimentación',
    chemistry_and_physics: 'Química y Física',
    environment: 'Medio Ambiente',
    people_and_family: 'Personas y Familia',
    team_work: 'Trabajo en Equipo',
    food: 'Alimento',
    self_control: 'Autocontrol',
    biology: 'Biología',
    flora: 'Flora',
    animals: 'Animales',
    how_stuff_is_made: 'Cómo se hacen los objetos',
    how_stuff_works: 'Cómo funcionan los objetos',
    resilience: 'Resiliencia',
    natural_phenomena: 'Fenómenos Naturales',
    places_and_landmarks: 'Lugares y Puntos de Referencia',
    human_body: 'Cuerpo Humano',
    geography: 'Geografía',
    digital_citizenship: 'Ciudadanía Digital',
    digital_literacy: 'Alfabetización digital',
    cancel: 'Cancelar'
  }
}
